<template>
  <div :class="[getSelectedDEV && 'dev-selected-component']" @contextmenu="selectComponentDEV($event, schema.model)">
    <v-card class="card-icon" v-bind="schema.attributesCard" @click="execute(schema.action)" :disabled="schema.readonly">
      <v-icon v-text="schema.attributesIcon.icon" v-bind="schema.attributesIcon"></v-icon>
      <h3 v-text="titleModel" :title="titleModel" v-bind="schema.attributesTitle"></h3>

      <p class="mb-0" v-if="schema.attributesSubtitle" v-text="subtitleModel" :title="subtitleModel" v-bind="schema.attributesSubtitle" />

      <div v-if="isString" v-for="item in formatValue(value)" :key="item.name" v-bind="schema.attributesDescription">
        {{item}}
      </div>

      <number
        v-else
        v-bind="schema.attributesDescription"
        ref="number"
        :from="0"
        :format="theFormat"
        :to="value"
        :duration="3"
        easing="Power4.easeOut"
      />
    </v-card>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import * as HANDLERS from '@/helpers/types/handlers';
import devComponentMixin from '@/mixins/dev-component-mixin';
import pageServices from '@/services/page';
import { compileDynamicString } from '@/helpers/page';

export default {
  mixins: [abstractField, devComponentMixin],

  data() {
    return {
      isString: true
    };
  },
  
  async mounted() {
    this.schema = await this.setup(this.schema);
    this.checkType();
  },

  methods: {
    formatValue(value){
      let format = [];

      if(value != undefined && value != null)
      {
        if(typeof value != 'string') value = value.toString();

        if(value.includes("||"))
        {
         value = value.split("||");
        }
        else
        {
          format.push(value);
          value = format;
        }
      }

      else
      {
        format.push('');
        value = format;
      }

      return value;
    },
    async setup(schema){
      return await this.getModel(schema);
    },
    async getModel(schema) {
      if (schema.procedure) {
        let pageName = schema.procedure.page ? schema.procedure.page : this.model.Page;
        let procedure = {
          name: schema.procedure.name,
          page: pageName ? pageName : ''
        };
        const { data } = await pageServices.executeProcedureAction(procedure);
        if (data.values.length) {
          const { titulo, subtitulo } = data.values[0];
          if(titulo !== undefined){
            schema.attributesTitle.title = titulo;
          }
          if(subtitulo !== undefined){
            schema.attributesSubtitle.title = subtitulo;
          }
        }
      }
      return schema;
    },

    theFormat(number) {
      return number.toFixed(0);
    },

    execute(action) {
      if (action) {
        action.mode = this.formOptions.mode;

        this.$emit(HANDLERS.EXECUTE_ACTION, { action, origin: this.formOptions.page });
      }
    },

    checkType() {
      if (/^[1-9]\d*(\.\d+)?$/.test(this.value)) {
        this.isString = false;
        this.$refs.number && this.$refs.number.play();
      } else {
        this.isString = true;
      }
    }
  },

  computed: {
    titleModel() {
      return compileDynamicString(
        {
          page: this.formOptions.page,
          mode: this.formOptions.mode,
          originalString: this.schema.attributesTitle.title
        }
      );
    },
    subtitleModel() {
      return compileDynamicString(
        {
          page: this.formOptions.page,
          mode: this.formOptions.mode,
          originalString: this.schema.attributesSubtitle.title
        }
      );
    }
  },

  watch: {
    value(newValue, oldValue) {
      this.checkType();
    }
  }
};
</script>
<style lang="scss" scoped>
.card-icon {
  padding: 10px;
  text-align: center;
}
</style>
